'use client'

import { AlertTriangle, Home, RefreshCcw } from 'lucide-react'
import Link from 'next/link'

import { cn } from '@/utils/cn'

type UserErrorPageProps = {
  error: Error & { digest?: string }
  reset: () => void
}

function UserErrorPage(props: UserErrorPageProps) {
  const { error, reset } = props
  return (
    <div className='flex min-h-screen items-center justify-center bg-gradient-to-b from-gray-900 to-gray-800 p-4'>
      <div className='w-full max-w-md'>
        <div
          className={cn(
            'rounded-xl border bg-gray-800/50 p-8 backdrop-blur-sm',
            'border-red-500/30 shadow-lg'
          )}
        >
          {/* Error Icon */}
          <div className='mb-6 flex justify-center'>
            <div className='rounded-full bg-red-500/20 p-4'>
              <AlertTriangle className='h-12 w-12 text-red-400' />
            </div>
          </div>

          {/* Error Message */}
          <div className='mb-8 text-center'>
            <h1 className='mb-4 text-2xl font-bold text-white'>
              Oops! Something went wrong
            </h1>
            <div className='mb-4 rounded-lg bg-gray-900/50 p-4'>
              <p className='break-all font-mono text-sm text-red-400'>
                {error.message}
              </p>
            </div>
            <p className='text-gray-400'>
              Don&apos;t worry, you can try refreshing the page or return to the
              home page.
            </p>
          </div>

          {/* Action Buttons */}
          <div className='flex flex-col justify-center gap-4 sm:flex-row'>
            <button
              onClick={reset}
              className='inline-flex items-center justify-center gap-2 rounded-lg bg-blue-500/10 px-6 py-3 text-blue-400 transition-colors hover:bg-blue-500/20'
            >
              <RefreshCcw className='h-5 w-5' />
              Try Again
            </button>
            <Link
              href='/landing'
              className='inline-flex items-center justify-center gap-2 rounded-lg bg-gray-700 px-6 py-3 text-white transition-colors hover:bg-gray-600'
            >
              <Home className='h-5 w-5' />
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UserErrorPage
